import { render, staticRenderFns } from "./inactiveColor-editor.vue?vue&type=template&id=6dbf4186&scoped=true"
import script from "./inactiveColor-editor.vue?vue&type=script&lang=js"
export * from "./inactiveColor-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf4186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbf4186')) {
      api.createRecord('6dbf4186', component.options)
    } else {
      api.reload('6dbf4186', component.options)
    }
    module.hot.accept("./inactiveColor-editor.vue?vue&type=template&id=6dbf4186&scoped=true", function () {
      api.rerender('6dbf4186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-switch/inactiveColor-editor.vue"
export default component.exports